import { createFileRoute } from "@tanstack/react-router";
import { CursosSector } from "@/components/cursos-sector";

const TITLE = "Cursos para Empresas de Construcción | Capacitación Empresas | Mine Class";
const DESCRIPTION =
  "Capacitación online para constructoras y sus cuadrillas: trabajos en altura, izaje y maquinaria, seguridad en obra e inducción de personal nuevo.";

export const Route = createFileRoute("/cursos/empresas/construccion")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://mine-class.com/cursos/empresas/construccion" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/empresas/construccion" }],
  }),
  component: () => <CursosSector sector="construccion" />,
});
